import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreatePdpV1WorkspacesWorkspaceIdPdpsPostData,
  type CreatePdpV1WorkspacesWorkspaceIdPdpsPostError,
  type CreatePdpV1WorkspacesWorkspaceIdPdpsPostResponse,
  createPdpV1WorkspacesWorkspaceIdPdpsPost,
} from '../../generated';

export type CreatePdpMutationVariables = CreatePdpV1WorkspacesWorkspaceIdPdpsPostData['path'] &
  CreatePdpV1WorkspacesWorkspaceIdPdpsPostData['body'];

export type CreatePdpMutation = CreatePdpV1WorkspacesWorkspaceIdPdpsPostResponse;

export const useCreatePdpMutation = <TError = CreatePdpV1WorkspacesWorkspaceIdPdpsPostError, TContext = unknown>(
  options?: Omit<
    UseMutationOptions<CreatePdpMutation, TError, CreatePdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreatePdpMutation, TError, CreatePdpMutationVariables, TContext>({
    mutationKey: ['CreatePdp'],
    mutationFn: async ({ workspace_id, ...body }: CreatePdpMutationVariables) => {
      const { data } = await createPdpV1WorkspacesWorkspaceIdPdpsPost({
        path: { workspace_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreatePdpMutation.fetcher = (
  { workspace_id, ...body }: CreatePdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createPdpV1WorkspacesWorkspaceIdPdpsPost({
      path: { workspace_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
